<template>
  <div class="d-flex">
    <v-col
      cols="12"
      md="4"
    >
      <v-card outlined>
        <v-card-text />
        <v-simple-table>
          <template v-slot:default>
            <tbody>
              <tr>
                <th class="text-left">
                  Full Name
                </th>
                <td>{{ supplier.firstName }} {{ supplier.lastName }}</td>
              </tr>
              <tr>
                <th class="text-left">
                  Gender
                </th>
                <td>{{ supplier.gender }}</td>
              </tr>

              <tr>
                <th class="text-left">
                  Date Of Birth
                </th>
                <td>{{ supplier.dateOfBirth }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
      <v-card
        outlined
        class="mt-3"
      >
        <v-card-text />
        <v-simple-table>
          <template v-slot:default>
            <tbody>
              <tr>
                <th class="text-left">
                  Identification
                </th>
                <td>{{ supplier.identification }}</td>
              </tr>

              <tr>
                <th class="text-left">
                  Tax Id
                </th>
                <td>
                  {{ supplier.taxId }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
    </v-col>
    <v-col
      cols="12"
      md="8"
    >
      <v-card
        outlined
        class="mt-3"
      >
        <v-card-text>
          <v-btn @click="$router.back()">
            Back
          </v-btn>
        </v-card-text>
        <v-simple-table dense>
          <template v-slot:default>
            <tbody>
              <tr>
                <th class="text-left">
                  Email
                </th>
                <td>{{ supplier.email }}</td>
              </tr>
              <tr>
                <th class="text-left">
                  Phone
                </th>
                <td>
                  {{ supplier.phone }}
                </td>
              </tr>
              <tr>
                <th class="text-left">
                  Company
                </th>
                <td>
                  {{ supplier.company }}
                </td>
              </tr>

              <tr>
                <th class="text-left">
                  Shipping Address
                </th>
                <td>
                  {{ supplier.shippingAdress }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
      <v-card
        outlined
        class="mt-3"
      >
        <v-card-text>
          <div>Supplied Products</div>

          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th>
                    Warehouse
                  </th>
                  <th>
                    Product Name
                  </th>
                  <th>
                    Stock keeping unit
                  </th>
                  <th>
                    Barcode
                  </th>
                  <th>
                    Type
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="product in products"
                  :key="product.id"
                >
                  <td>
                    <router-link
                      :to="{
                        name: 'WarehouseDetail',
                        params: { id: product.warehouseSaleFrom },
                      }"
                    >
                      #Warehouse
                    </router-link>
                  </td>
                  <td>{{ product.name }}</td>
                  <td>{{ product.sku }}</td>
                  <td>{{ product.barcode }}</td>
                  <td>{{ product.type }}</td>
                  <td>{{ product.unitOfMeasure }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-col>
  </div>
</template>

<script>
export default {
  data() {
    return {
      supplier: {},
      products: {},
    };
  },
  mounted() {
    if (this.$route.params.id) {
      window.axios
        .get("/supplier/" + this.$route.params.id)
        .then((response) => {
          this.$data.supplier = response.data.supplier;
          this.$data.products = response.data.products;
        });
    }
  },
};
</script>
